export const coreCandle = {
  deployer: '0x546D090bbcEC3d96903d41e38C3436c1C601AF9c',
  factory: '0x251cd2C527Eca282a8C6A4Ef75EfAb19A9Ac5796',
  feeReceiver: '0x546D090bbcEC3d96903d41e38C3436c1C601AF9c',
  feeSetter: '0x546D090bbcEC3d96903d41e38C3436c1C601AF9c'
}

export const peripheryCandle = {
  router: '0x252D8FDAA323094fe43cCa93ad8e650fC72521A7'
}
